import { render, staticRenderFns } from "./TuitionTeacher.vue?vue&type=template&id=63d0d8ee&"
import script from "./TuitionTeacher.vue?vue&type=script&lang=js&"
export * from "./TuitionTeacher.vue?vue&type=script&lang=js&"
import style0 from "./TuitionTeacher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports